import { Layers } from "lucide-react";
import type { ReactNode } from "react";
import { Badge } from "../../web/components/ui";
import type { PricingGroupRow } from "./meta";
import { LockMark } from "./PriceLock";
import { usePriceListWindows } from "./windows";

/**
 * The top of an item's card for its group, the same for its pricing and its name tags: the group, its lock, what this item
 * overrides (`badge`, blue), what the group sets (`summary`), and on the right its buttons (`actions`: Override...) then Open
 * group. As tall with the badge as without, so nothing under it moves when one comes or goes.
 */
export function GroupCardHeader(
    props: Readonly<{
        group: Pick<PricingGroupRow, "id" | "name" | "locksPrices">;
        badge?: { text: string; title: string };
        summary: ReactNode;
        actions?: ReactNode;
        /** What Open group shows ("its pricing and all its items"). */
        opens: string;
    }>,
) {
    const { group, badge } = props;
    const windows = usePriceListWindows();
    return (
        <div className="flex flex-wrap items-center justify-between gap-x-3 gap-y-2">
            <div className="min-w-0 space-y-0.5">
                <p className="m-0 flex min-h-5 flex-wrap items-center gap-x-1.5 gap-y-1 leading-5">
                    <Layers className="size-4 shrink-0 text-brand-ink" />
                    <span className="font-semibold">{group.name}</span>
                    <LockMark lock={group.locksPrices ? { by: "group", group: group.name } : null} />
                    {badge ? (
                        <Badge tone="blue" title={badge.title}>
                            {badge.text}
                        </Badge>
                    ) : null}
                </p>
                <p className="m-0 text-muted whitespace-pre-line">{props.summary}</p>
            </div>
            <div className="flex shrink-0 flex-wrap items-center gap-1.5">
                {props.actions}
                <button type="button" className="btn-secondary" title={`Its window: ${props.opens}`} onClick={() => windows.openGroup(group.id)}>
                    Open group
                </button>
            </div>
        </div>
    );
}
